import React from 'react';
import { Moon, Sun } from 'lucide-react';
import CourseSearch from './CourseSearch';
import './Header.css';

const VIEW_LABELS = {
  portal:       'My learning',
  catalogue:    'Course catalogue',
  library:      'Library',
  lesson:       'Lesson',
  certificates: 'Certificates',
  profile:      'My profile',
  feedback:     'Feedback inbox',
  admin:        'Admin dashboard',
  users:        'Users',
  'course-edit': 'Edit course',
  'presentation-studio': 'Presentation studio',
  compliance:   'Compliance',
  audit:        'Activity log',
  organisation: 'My organisation',
  organisations: 'Organisations',
};

export default function Header({ view, theme, onToggleTheme, user, enrollments, onSearchCourse, onSearchLesson }) {
  const label = VIEW_LABELS[view] || 'Okiru Learn';

  return (
    <header className="header">
      <div className="header-left">
        <h1 className="header-title">{label}</h1>
      </div>
      <CourseSearch user={user} enrollments={enrollments} onSelectCourse={onSearchCourse} onSelectLesson={onSearchLesson} />
      <div className="header-right">
        <a className="header-help" href="mailto:tmoahi@okiru.co.za?subject=Okiru%20Learn%20help">Help</a>
        <button
          type="button"
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-pressed={theme === 'dark'}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {theme === 'light' ? <Moon size={18} strokeWidth={1.75} aria-hidden="true" /> : <Sun size={18} strokeWidth={1.75} aria-hidden="true" />}
        </button>
      </div>
    </header>
  );
}
